import React, {Component} from 'react'
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import {fetchData} from '../../../utils/data.js'
import withConfig from '../../wrappers/withConfig.js';
import { format } from "date-fns";
import PageNavigation from '../../../utils/PageNavigation'
import AdvancedSearchResults from './AdvancedSearchResults.js'
import BackButton from '../../elem/BackButton.js';
import DatepickerComponent from '../../datepicker.component.js';
import { Helmet } from 'react-helmet';



class DisclosureAdvanced extends Component{
    constructor(props) {
        super(props)
        this.handleStateChange = this.handleStateChange.bind(this);
        this.populateCounty = this.populateCounty.bind(this);
        this.apiURL= props.config.API_URL
        this.state = {
            query: '',
            results: {},
            formResults: {},
            totalCount: '',
            pageNo: 1,
            //state
            selectedState: null,
            stateNumber: '',
            state_name: '',
            stateNames: [],
            //county
            countyNumber: '',
            selectedCounty: null,
            countyNames: [],
            //ingredient
            ingredientNames: [],
            ingredientNameList: [],
            isLoading: true,
            //well
            wellNames: [],
            selectedWell: null,
            selectedWellName: '',
            wellname: '',
            //operator
            operatorNames: [],
            selectedOperator: '',
            Operator_No: '',
            //job dates
            jobstart: '',
            selectedjobstart: '',
            jobend: '',
            selectedjobend: '',
            cas_no: '',
            api_no: '',
            //pagination
            totalResults: 0,
            totalPages: 0,
            currentPageNo: 0,
            resultsPerPage: 200,
            nextPageNumber: '',
        }
    }

    //pagination
    getPageCount = (total, denominator) => {
        const divisible = total % denominator === 0;
        const valueToBeAdded = divisible ? 0 : 1;
        return Math.floor(total / denominator) + valueToBeAdded;
    };

    handlePageClick = (event, type) => {
        // event.preventDefault();
        const updatedPageNo =
                  'prev' === type
                      ? this.state.currentPageNo - 1
                      : this.state.currentPageNo + 1;
        if (!this.state.loading) {
            this.setState({ loading: true, message: '' }, () => {
                this.handleSubmit(event, updatedPageNo, this.state.query);
            });
        }
    };
    
    // form handlers and api's **********************************
    populateWells(county_code) {
        const wellSearchURL = `${this.apiURL}/fracfocus/wellnamesbystateandcountyids?countyid=${county_code}&stateid=${this.state.stateNumber}`
        const then = data => {
            const resultNotFound = ! data.length
                    ? 'There are no more search results.'
                    : '';
                this.setState({
                    results: data,
                    message: resultNotFound,
                    loading: false
                })
                this.setState({ wellNames: data.data })
        }
        const onError = error => {
            this.setState({
                    loading:false,
                    message: 'Failed to fetch the data. Please check network'
                })
            console.log(error)
        }
        fetchData(wellSearchURL, then, onError)
    };

    populateCounty(state_no) {
        const countySearchURL = `${this.apiURL}/state/countiesbystateid?stateid=${state_no}`
        const then = data => {
            const resultNotFound = ! data.length
                    ? 'There are no more search results.'
                    : '';
                this.setState({
                    results: data,
                    message: resultNotFound,
                    loading: false
                })
                this.setState({ countyNames: data.data })
        }
        const onError = error => {
            this.setState({
                    loading:false,
                    message: 'Failed to fetch the data. Please check network'
                })
            console.log(error)
        }
        fetchData(countySearchURL, then, onError)
    };

    handleStateChange(event) {
        this.setState({ selectedState: event })
        if(event != null){
            this.setState({ selectedCounty: '' })
            this.setState({ stateNumber: event.value })
            this.setState({ state_name: event.label })
            this.populateCounty(event.value)
        }
        else{
            //api params
            this.setState({ stateNumber: '' })
            this.setState({ state_name: '' })
            this.setState({ countyNumber: '' })
            this.setState({ wellname: '' })
            //dropdown values
            this.setState({ countyNames: [] })
            this.setState({ wellNames: [] })
            //form values
            this.setState({ selectedCounty: '' })
            this.setState({ selectedWell: '' })
        }
    }

    handleCountyChange = (event) => {
        this.setState({ selectedCounty: event })
        if(event != null){
            this.setState({ countyNumber: event.value })
            this.populateWells(event.value)
        }
        else{
            //api params
            this.setState({ countyNumber: '' })
            this.setState({ wellname: '' })
            //dropdown values
            this.setState({ wellNames: [] })
            //form values
            this.setState({ selectedWell: '' })
        }
    }
    handleWellChange = (event) => {
        this.setState({ selectedWell: event }) 
        if(event != null){
            this.setState({ wellname: event.value })
        }
        else{
            //api params
            this.setState({ wellname: '' })
            //form values
            this.setState({ selectedWell: '' })
        }
    }
    handleOperatorChange = (event) => {
        this.setState({ selectedOperator: event })
        if(event != null){
            this.setState({ Operator_No: event.value })
        }
        else{
            this.setState({ Operator_No: '' })
        }
    }
    handleJobStartChange = (event) => {
        // const date = format(new Date(), 'yyyy-MM-dd');
        // const apiStartDate = format(event, 'yyyy-MM-dd')
        this.setState({ selectedjobstart: event })
        this.setState({ jobstart: event.target.value })
    }
    handleJobEndChange = (event) => {
        this.setState({ selectedjobend: event })
        this.setState({ jobend: event.target.value })
    }
    handleWellNameChange = (event) => {
        this.setState({ wellname: event.target.value })
    }
    handleCASChange = (event) => {
        this.setState({ cas_no: event.target.value })
    }
    handleAPIChange = (event) => {
        this.setState({ api_no: event.target.value })
    }
    handleIngredientChange = (event) => {
        this.setState({ingredientNameList: event})
    }
    
    // Submit*****************************************************
    handleSubmit = ( event, updatedPageNo = '', query ) => {
        event.preventDefault()
        if (this.state.stateNumber == '' &&
            this.state.state_name  == '' &&
            this.state.countyNumber == '' &&
            this.state.Operator_No == '' &&
            this.state.jobstart == '' &&
            this.state.jobend == '' &&
            this.state.wellname == '' &&
            this.state.cas_no == '' &&
            this.state.ingredientNameList == '' &&
            this.state.api_no == '') {
                window.alert('No criteria entered.')
            }
        const pageNumber = updatedPageNo ? `&page=${updatedPageNo}` : '';
        const operatorFormat = encodeURIComponent(`${this.state.Operator_No}`)
        const searchURL = `${this.apiURL}/fracfocus/search?state_code=${this.state.stateNumber}&state_name=${this.state.state_name}&county_code=${this.state.countyNumber}&operator_name=${operatorFormat}&start_date=${this.state.jobstart}&end_date=${this.state.jobend}&well_name=${this.state.wellname}&cas_number=${this.state.cas_no}&ingredient_name=${this.state.ingredientNameList.map(x => x.value).join('$')}&api_number=${this.state.api_no}&page=${updatedPageNo}`
        if( this.cancel ){
            this.cancel.cancel();
        }
        this.cancel = axios.CancelToken.source();

        axios.get( searchURL, {
            cancelToken: this.cancel.token
        } )
            .then( res => {
                const total = res.data.Count;
                const totalPagesCount = this.getPageCount( total, 200 );
                const resultNotFound = ! res.data.Wells
                                        ? 'There are no more search results.'
                                        : '';
                this.setState({
                    formResults: res.data.Wells,
                    totalResults: total,
                    currentPageNo: updatedPageNo,
                    nextPageNumber: updatedPageNo,
			        totalPages: totalPagesCount,
                    message: resultNotFound,
                    loading: false
                })
            })
            .catch ( error => {
                if( axios.isCancel(error) || error ){
                    this.setState({
                        loading:false,
                        message: 'Failed to fetch the data. Please check network'
                    })
                    console.log(error)
                }
            })
    };
    
    fetchStates() {
        const stateURL = `${this.apiURL}/state/states`
        const then = data => {
            this.setState({stateNames : data.data})
        }
        function onError(error){
            console.log(error)
        }
        fetchData(stateURL, then, onError)
    }

    fetchOperators() {
        const operatorURL = `${this.apiURL}/operator/operators`
        const then = data => {
            this.setState({operatorNames : data.data})
        }
        function onError(error){
            console.log(error)
        }
        fetchData(operatorURL, then, onError)
    }

    fetchIngredients() {
        const ingredientURL = `${this.apiURL}/fracfocus/ingredients`

        const then = data => {
            const ingredients = data && data.data ? data.data
            .sort((a, b) => a.IngredientName.localeCompare(b.Ingredient))
            .map(x=>({label: x.Ingredient, value: x.IngredientName})) : []
            this.setState({ingredientNames : ingredients, isLoading: false})
        }
        function onError(error){
            console.log(error)
        }
        fetchData(ingredientURL, then, onError)
      }

    componentDidMount() {
        // this () runs once on page load
        this.fetchStates()
        this.fetchOperators()
        this.fetchIngredients()
    }

    resetForm = () => { 
        window.location.reload(false);
        // this.setState({
        //     selectedState: null,
        //     stateNumber: '',
        //     countyNumber: '',
        //     selectedCounty: null,
        //     countyNames: [],
        //     wellNames: [],
        //     selectedWell: null,
        //     selectedWellName: '',
        //     selectedOperator: '',
        //     selectedjobstart:'',
        //     selectedjobend:'',
        //     jobstart: '',
        //     jobend: '',
        //     wellname: '',
        //     cas_no: '',
        //     api_no: '',
        //     formResults: {},
        //   });
        }

    render() {
        const { pager, pageOfItems, selectedState, stateNames, selectedCounty, countyNames, wellNames, ingredientNames, ingredientNameList, selectedWell, selectedIngredient, operatorNames, selectedOperator, jobstart, selectedjobstart, jobend, selectedjobend, wellname, cas_no, ingredient, api_no } = this.state
        const { query, loading, message, currentPageNo, totalPages, nextPageNumber } = this.state;
        const showPrevLink = 1 < currentPageNo;
        const showNextLink = totalPages > currentPageNo;
        const { formResults } = this.state;
        const date = format(new Date(), 'MM-dd-yyyy');
        const wellDisclosureURL = `${this.apiURL}/`
        const showing_start = this.state.currentPageNo == 1 ? 1 : (this.state.resultsPerPage * (this.state.currentPageNo-1)) + 1
        const showing_end = this.state.resultsPerPage * this.state.currentPageNo

        return(
            <div>
                <Helmet>
                    <title>Advanced Search</title>
                    <link rel="icon" href="/favicon.ico" />
                </Helmet>
                <div className="return">
                    <BackButton label={'SWITCH TO MAP SEARCH'} />
                </div>
                <hr className="page_break" />
                <div className="advanced_form">
                    <form id="advanced_form_input" onSubmit={(event) => this.handleSubmit(event, this.state.pageNo, this.state.query)}>
                    <h2 className="findwells">Advanced Search</h2>
                        {/* <div className="search_panel"> */}
                            <div className='advanced_row_form'>
                                <div className="advanced_input">
                                    <label>State</label>
                                    <Select options={ stateNames.map(x=>({label: x.StateName, value: x.State_No})) } value={selectedState} onChange={this.handleStateChange} isClearable={this.handleStateChange} placeholder='Select A State'/>
                                </div>
                                <div className="advanced_input">
                                    <label>County</label>
                                    <Select options={ countyNames.map(x=>({label: x.CountyName, value: x.Code})) } value={selectedCounty} onChange={this.handleCountyChange} isDisabled={this.state.selectedState ? false : true} isClearable={this.handleCountyChange} placeholder='Select A County'/>
                                </div>
                                <div className="advanced_input">
                                    <label>Wells Within County</label><br />
                                    <Select options={ wellNames.map(x=>({label: x.WellName, value: x.WellName})) } value={ selectedWell } onChange={this.handleWellChange} isDisabled={this.state.selectedCounty ? false : true}isClearable={this.handleWellChange} placeholder='Select A Well'/>
                                </div> <br /> <br />
                                <div className="advanced_input">
                                    <label>Operator</label><br />
                                    <Select options={ operatorNames.map(x=>({label: x.OperatorName, value: x.OperatorName})) } value={ selectedOperator } onChange={this.handleOperatorChange} isClearable={this.handleOperatorChange} placeholder='Select An Operator'/>
                                </div>
                                <div className="advanced_date">
                                    <label>Job Date Range</label><br />
                                    <DatepickerComponent selected={selectedjobstart} value={ jobstart } onChange={this.handleJobStartChange}/> 
                                    to:
                                    <DatepickerComponent selected={selectedjobend} value={ jobend } onChange={this.handleJobEndChange}/>
                                </div>
                                <div className="advanced_input">
                                    <label>Well Name</label><br />
                                    <input className="advanced_input_text" type='text' value={ wellname } onChange={this.handleWellNameChange} placeholder='Enter a Well Name'/>
                                </div><br /> <br />
                                <div className="advanced_input">
                                    <label>CAS Number</label><br />
                                    <input className="advanced_input_text" type='text' value={ cas_no } onChange={this.handleCASChange} placeholder='Enter a CAS Number'/>
                                </div>
                                <div className="advanced_input">
                                    <label>API Well Number</label><br />
                                    <input className="advanced_input_text" type='text' value={ api_no } onChange={this.handleAPIChange} placeholder='Enter an API Number'/>
                                </div>
                                <div className="advanced_input_ing">
                                    <label>Ingredients</label><br />
                                    <AsyncSelect height={70} autosize={true} isLoading={this.state.isLoading} defaultOptions={ingredientNames.slice(0,50)} loadOptions={(inputValue, callback) => {callback(ingredientNames.filter(x => x.label.toLowerCase().includes(inputValue.toLowerCase())).slice(0,50))}} isMulti value={ ingredientNameList } onChange={this.handleIngredientChange} placeholder='Select An Ingredient'/>
                                </div> 
                            {/* </div> */}

                        </div>
                        <br />
                        {/* buttons */}
                        <button className="advanced_search_button" type="submit" aria-hidden="true">
                            <a className="link_white">Search Jobs</a>
                        </button>
                        <button onClick={this.resetForm} className="advanced_search_reset">
                            <a className="link_white">Reset</a>
                        </button>
                    </form>
                </div><br />

                {/* Results */}
                {this.state.formResults ?
                <div>
                    {/* Results Component  */}
                    <AdvancedSearchResults 
                        formResults={this.state.formResults}
                        totalhits={this.state.totalResults}
                        wellURL={wellDisclosureURL} 
                        show_start={showing_start} 
                        show_end={showing_end}
                    />

                    {totalPages > 1 ?
                    <PageNavigation
                        totalPages={totalPages}
                        currentPage={currentPageNo}
                        loading={loading}
                        showPrevLink={showPrevLink}
                        showNextLink={showNextLink}
                        show_start={showing_start}
                        show_end={showing_end}
                        total={this.state.totalResults}
                        type='JOBS'
                        handlePrevClick={(event) => this.handlePageClick(event, 'prev')}
                        handleNextClick={(event) => this.handlePageClick(event, 'next')}
                    />
                    : ''} 
                </div> 
                : ''}
            </div>

            
        )
    }
}
export default withConfig(DisclosureAdvanced)